import React from 'react';
import ColorBtn from './colorBtn'
import GitHubButton from 'react-github-btn'


class Side extends React.Component {

    
    render() {
        const textOfMe = "Hi there! My name is Ziao Wang. I am currently a student (a prospective engineer as well!) in Columbia University. I am also an incoming software engineer at Google Search team!"
        return (
            <div className="sideConent">
                <div className="container">
                    <div className="row">
                        <img src={require("./img/myselifi2.png")} alt="" />
                    </div>
                    <div className="row" name="text" align="left" style={{width:"100%"}}>
                        {textOfMe}
                    </div>
                    <div className="row" name="text">
                        austinwong95 at hotmail dot com
                    </div>
                    <div className="row">
                    <GitHubButton href="https://github.com/wzao1515" data-size="large" aria-label="Follow @wzao1515 on GitHub">@wzao1515</GitHubButton>
                    </div>
                    <div className="row">
                        <div style={{display: 'flex', justifyContent: 'center'}}>
                            <ColorBtn /> 
                        </div>
                    </div>
                    <div className="row">
                        <div className="tags footer-tags">
                            <a className="button cpp">C++</a>
                            <a className="button python">Python</a>
                            <a className="button react">React</a>
                            <a className="button bootstrap">NLP</a>
                            <a className="button sql">SQL</a>

                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Side;